import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GlobalVariable } from '../../app/app.global';
import { LoadingComponent } from '../home/paraEmpresas/modalLoading/content.component';
import { BindComponentService } from '../../app/utils/bind.component.service';
import { ModalTimeOut } from '../home/paraEmpresas/modaltimeout/content.component';
  import * as _ from "lodash";

/**
 * @author Wesley Mascarenhas
 * @version $Id$
 */
export abstract class CommonService {

  public baseURL: string;
  public baseURLCompanyInfo: string;
  public requestOptions: RequestOptions;
  public json:string;
  public authenticatedUser: any;
  public isModalTimeOut:boolean = false;

  protected constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    this.baseURL = GlobalVariable.BASE_URL_API;
    this.baseURLCompanyInfo =  GlobalVariable.BASE_URL_API + '/datapackcompanyinfo';
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json; charset=UTF-8');
    headers.append('Accept', 'application/json');
    headers.append("Cache-Control", "no-cache");
    headers.append("Pragma", "no-cache");
    this.requestOptions = new RequestOptions({
      headers: headers
    });
  }

  public convertResponse(response: Observable<Response>): Observable<Response> {
    let json:string;
    return response
      .map((res: Response) => res.json())
      .catch((err: Response) => this.errJson(err.json()));
  }


  public errJson(err: Response){
    let error = Observable.throw(err.json ? this.errJson(err.json()) : err);
    if(error.error.code==='LOGIN_EXPIRED' && !this.isModalTimeOut){
      this.openModalTimeOut();
      this.isModalTimeOut = true;
    }
    return error;
  }

  private openModalTimeOut() {
    this.modalService.open(ModalTimeOut, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  private responseSessionUser(response: Observable<Response>) {
    return response
      .map((res: Response) => {
        this.authenticatedUser = res.json();
        return this.authenticatedUser;
      })
      .catch((err: Response) => Observable.throw(err.json ? err.json() : err) );
  }

  public httpGet(url:string): Observable<Response>{
    let authenticatedUser  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
   
    if(!_.isNil(authenticatedUser)){
      url += '&sessionId=' + authenticatedUser['sessionId'];
      url += '&remoteHost=' + authenticatedUser['remotehost'];
      url += '&remoteIp=' + authenticatedUser['remoteIp'];
      url += '&acessLogin=' + authenticatedUser['user'];
    }  
    return this.http.get(url, this.requestOptions);
  }

  public httpPost(url:string,data:any): Observable<Response>{
    let authenticatedUser  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
   
    if(!_.isNil(authenticatedUser)){
      data['sessionId'] = authenticatedUser['sessionId'];
      data['remoteHost'] = authenticatedUser['remotehost'];
      data['remoteIp'] = authenticatedUser['remoteIp'];
      data['acessLogin'] = authenticatedUser['user'];
    }  
    return this.http.post(url, data, this.requestOptions);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/common.service.ts